var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProband(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 7.1799998 22",
    id: "svg13",
    width: 7.1799998,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g13",
    transform: "translate(-13.95,-71.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 15.82,81.13 c 0.55,0.2 1.13,0.3 1.72,0.3 0.59,0 1.17,-0.1 1.72,-0.3 0.17,0.29 0.25,0.62 0.25,0.97 v 7.93 c 0,1.09 -0.89,1.98 -1.98,1.98 -1.09,0 -1.98,-0.89 -1.98,-1.98 V 82.1 c 0,-0.35 0.09,-0.68 0.25,-0.97 m 3.79,-1.84 c -0.58,0.4 -1.28,0.64 -2.04,0.64 -0.76,0 -1.46,-0.24 -2.04,-0.64 -0.87,0.63 -1.43,1.66 -1.43,2.81 v 7.93 c 0,1.92 1.56,3.48 3.48,3.48 v 0 c 1.92,0 3.48,-1.56 3.48,-3.48 V 82.1 c 0,-1.16 -0.57,-2.18 -1.43,-2.81 v 0 z",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "m 17.54,73.01 c 1.15,0 2.09,0.94 2.09,2.09 0,1.15 -0.94,2.09 -2.09,2.09 -1.15,0 -2.09,-0.94 -2.09,-2.09 0,-1.15 0.94,-2.09 2.09,-2.09 m 0,-1.5 c -1.98,0 -3.59,1.61 -3.59,3.59 0,1.98 1.61,3.59 3.59,3.59 1.98,0 3.59,-1.61 3.59,-3.59 0,-1.98 -1.61,-3.59 -3.59,-3.59 z",
    id: "path12"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProband);
export default __webpack_public_path__ + "static/media/Proband.c70d8ec9829091d240c1e8646eabb1ec.svg";
export { ForwardRef as ReactComponent };